import AddShopBasketItemRequestModel from '../../generated/types/model/resource/AddShopBasketItemRequestModel';

export default class AddShopBasketItemRequestViewModel extends AddShopBasketItemRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
